import React from "react";
import { Header } from "Components/DP/DPTable/DPTable";
import { DPTable, DPEmptyTable, DPComponentLoader } from "Components/DP";
import NetEarningsTableRow from "../NetEarningsTableRow/NetEarningsTableRow";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { GetNetEarningsFilesQuery, GetNetEarningsFilesQueryVariables } from "generated/graphql";
import { usePayrollAnomalies } from "Hooks/usePayrollAnomalies";

enum NetEarningsColumns {
  date = "Date/Time",
  uploader = "Uploader",
  fileName = "File Name",
  status = "Status",
  submission = "Submission",
  payrollAnomaly = "Payroll Anomaly",
}

const netEarningsHeaders: Header[] = [
  NetEarningsColumns.date,
  NetEarningsColumns.uploader,
  NetEarningsColumns.fileName,
  NetEarningsColumns.status,
];

const NetEarningsTable = () => {
  const { permissions } = usePartnerConfig();
  const { disablePayrollAnomaly } = usePayrollAnomalies();

  const shouldDisplaySubmission = permissions.canViewGrossEarnings;
  const shouldDisplayPayrollAnomaly = permissions.canViewGrossEarnings && !disablePayrollAnomaly;
  const headers = [...netEarningsHeaders];

  if (shouldDisplaySubmission) {
    headers.push(NetEarningsColumns.submission);
  }

  if (shouldDisplayPayrollAnomaly) {
    headers.push(NetEarningsColumns.payrollAnomaly);
  }

  const [page, setPage] = React.useState(1);
  const rowsPerPage = parseInt(
    process.env.REACT_APP_DATA_EXCHANGE_PER_PAGE!,
    10
  );
  const { data, refetch, loading } = useQuery<
    GetNetEarningsFilesQuery,
    GetNetEarningsFilesQueryVariables
  >(
    queries.GET_NET_EARNINGS_FILES_QUERY,
    {
      variables: {
        page,
        perPage: rowsPerPage,
      },
    }
  );
  const totalCount = data?.payrollJournalFiles?.totalCount || 0;

  const onChangePageFn = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  React.useEffect(() => {
    refetch({ page });
  }, [page, refetch]);
  return (
    <DPTable
      page={page}
      rowsPerPage={rowsPerPage}
      count={totalCount}
      headers={headers}
      onChangePage={onChangePageFn}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          data?.payrollJournalFiles?.items.length ? (
            <>
              {data.payrollJournalFiles.items.map(file => (
                <NetEarningsTableRow
                  key={file.id}
                  netEarningsFile={file}
                  disablePayrollAnomaly={!shouldDisplayPayrollAnomaly}
                />
              ))}
            </>
          ) : (
            <DPEmptyTable message={"Uploads will appear here once created"} />
          )
        }
      />
    </DPTable>
  );
};

export default NetEarningsTable;
